<template>
	<b-modal
		hide-footer
		ref="modal-view-inherited"
		size="lg"
		title="Tarifas heredadas"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-row>
			<b-col cols="12" class="mb-2">
				<h5>[{{ modelId }}] {{ parentRateName }}</h5>
				<div class="alert-info alert show">
					<p class="mb-0 small">
						<md-icon icon="info" /> El siguiente listado de tarifas, son las tarifas que están siendo heredadas bajo el actual plan tarifario: <br> <ins>[{{modelId}}] {{ parentRateName }}</ins>
					</p>
				</div>
				<hr />
			</b-col>

			<b-form-group class="col-lg-12">
				<div class="alert-light alert bg-light">
					<p class="mb-1"><strong>Resumen de tarifa</strong></p>
					<hr />
					<p class="mb-0">
						Área: <strong>{{ area }}</strong
						><br />
						Moneda: <strong>{{ currency }}</strong
						><br />
						Tipos de servicio:<br />
					</p>
					<ul>
						<li
							v-for="serviceType in serviceTypes"
							:key="serviceType.value"
						>
							{{ serviceType.text }}
						</li>
					</ul>
				</div>
			</b-form-group>

			<b-col lg="12">
				<b-row>
					<b-col lg="12" class="mb-3">
						<!-- <pre>{{inheritedRates}}</pre> -->
						<b-table :fields="ratePlansColumns" small striped hover bordered :items="inheritedRates" show-empty>
							<template v-slot:cell(type)="row">
								<md-icon class="sc-color" icon="airport_shuttle" v-if="row.item.supplierName != ''" />
								<md-icon class="text-info" icon="store" v-else />
								{{row.item.supplierName != "" ? 'Proveedor' : 'Canal de Venta'}}
							</template>
							<template v-slot:cell(typeName)="row">
								{{row.item.supplierName != "" ? row.item.supplierName : row.item.salesChannelName}}
							</template>
							<template v-slot:cell(title)="row">
								[{{row.item.id}}] {{row.item.title}}
							</template>
							<template v-slot:cell(actions)="row">
								<b-button
									@click="event => removeInheritance(row.item, row.index, event)"
									type="button"
									v-if="$hasPermission('rates.delete')"
									size="sm"
									class="mr-1"
									variant="info"
									content="Desvincular herencia"
									v-tippy="{ arrow: true, arrowType: 'round' }"
								>
									<md-icon icon="link_off" />
								</b-button>
							</template>
							<template #empty>
								<p class="text-center mb-0">No se encontraron registros</p>
							</template>
						</b-table>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
export default {
	data() {
		return {
			modelId: -1,
			loading: true,
			area: "",
			parentRateName: "",
			currency: "",
			inheritedRates: [],
			serviceTypes: [],
			ratePlansColumns : [
				{key:'type', label:'Tipo'},
				{key:'typeName', label:'Nombre'},
				{key:'title', label:'Nombre de plan tarifario'},
				{key:'actions', label:'.'},
			],
		};
	},
	methods: {
		loadModel(id) {
			this.modelId = id;
			this.loadInheritedRates();
			this.loadParent();
			this.$refs["modal-view-inherited"].show();
		},
		loadInheritedRates() {
			this.loading = true;
			this.$root.api
				.get(`/rate-plans/${this.modelId}/inherited`)
				.then(res => {
					this.inheritedRates = res.data;
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadParent() {
			this.loading = true;
			this.$root.api
				.get(`/rate-plans/${this.modelId}`)
				.then(res => {
					this.area = res.data.zonedArea.name;
					this.parentRateName = res.data.title;
					this.currency = res.data.currency.toUpperCase();

					this.serviceTypes = res.data.serviceTypes.map(st => ({
						value: st.id,
						text: st.name
					}));
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		removeInheritance(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					this.$root.api
						.post(`rate-plans/break-inheritance`, {
							parentRatePlanId: item.parentRatePlanId,
							ratePlanId: item.id
						})
						.then(response => {
							if (response.data.error) {
								this.$root.showAlert(response.data.message, {
									variant: "warning"
								});
								close();
								return false;
							}

							this.$root.showAlert(response.data);
							this.loadInheritedRates()
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		}
	},
};
</script>
<style scoped>
.sc-color {
	color: #4f39cf;
}
</style>
